var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactoring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.05859 8.08325V18.0583C9.05859 18.8749 9.44193 19.6499 10.1003 20.1416L14.4419 23.3916C15.3669 24.0832 16.6419 24.0832 17.5669 23.3916L21.9086 20.1416C22.5669 19.6499 22.9502 18.8749 22.9502 18.0583V8.08325H9.05859Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3346 8.70825H7.66797C7.3263 8.70825 7.04297 8.42492 7.04297 8.08325C7.04297 7.74159 7.3263 7.45825 7.66797 7.45825H24.3346C24.6763 7.45825 24.9596 7.74159 24.9596 8.08325C24.9596 8.42492 24.6763 8.70825 24.3346 8.70825Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3346 13.2917H12.668C12.3263 13.2917 12.043 13.0084 12.043 12.6667C12.043 12.3251 12.3263 12.0417 12.668 12.0417H19.3346C19.6763 12.0417 19.9596 12.3251 19.9596 12.6667C19.9596 13.0084 19.6763 13.2917 19.3346 13.2917Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3346 17.4583H12.668C12.3263 17.4583 12.043 17.1749 12.043 16.8333C12.043 16.4916 12.3263 16.2083 12.668 16.2083H19.3346C19.6763 16.2083 19.9596 16.4916 19.9596 16.8333C19.9596 17.1749 19.6763 17.4583 19.3346 17.4583Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoring);
export default __webpack_public_path__ + "static/media/factoring.243206b4081df0173855b530a3b97f90.svg";
export { ForwardRef as ReactComponent };